import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getUserSettingsSelector } from '../../common/redux/userSettings/userSettingsSlice';
import authorizationService from '../../common/services/security/authorizationService';
import { getPendoServicePromise } from './helper';
import userTokenService from '../../common/services/security/userTokenService';

export const PendoStarter = ({ children }) => {
  const userSettings = useSelector(getUserSettingsSelector);

  useEffect(() => {
    const startPendoService = async () => {
      if (
        authorizationService.hasValidToken() &&
        userSettings.loaded &&
        userTokenService.isActiveAnalyticsTerritory()
      ) {
        if (userSettings.settings.allowPerformanceCookies) {
          await getPendoServicePromise();
        }
      }
    };
    startPendoService();
  }, [userSettings]);
  return children;
};
